import { trackEvent } from "helpers/analytics";
import { RequestStatus } from "types/request";

type WorkforceActionTypes =
  | IJoinWorkforcePilotAction
  | IViewWorkforceTeaserAction
  | ICheckWorkforceCookieAction;

enum WorkforceTypeKeys {
  JOIN_WORKFORCE_PILOT = "WORKFORCE/JOIN_WORKFORCE_PILOT",
  VIEW_WORKFORCE_TEASER = "WORKFORCE/VIEW_WORKFORCE_TEASER",
  CHECK_WORKFORCE_COOKIE = "WORKFORCE/CHECK_WORKFORCE_COOKIE",
}

interface IJoinWorkforcePilotAction {
  type: WorkforceTypeKeys.JOIN_WORKFORCE_PILOT;
}

interface IViewWorkforceTeaserAction {
  type: WorkforceTypeKeys.VIEW_WORKFORCE_TEASER;
}

interface ICheckWorkforceCookieAction {
  requestStatus: RequestStatus;
  type: WorkforceTypeKeys.CHECK_WORKFORCE_COOKIE;
  cookieValue: boolean;
}

function viewWorkforceTeaser(): IViewWorkforceTeaserAction {
  trackEvent("view workforce teaser");
  return { type: WorkforceTypeKeys.VIEW_WORKFORCE_TEASER };
}

function joinWorkforcePilot(): IJoinWorkforcePilotAction {
  trackEvent("join workforce pilot");
  window.localStorage.setItem("WorkforcePilotRequest", "true");
  return { type: WorkforceTypeKeys.JOIN_WORKFORCE_PILOT };
}

function checkWorkforceCookie(): ICheckWorkforceCookieAction {
  const workforcePilotCookie = !!window.localStorage.getItem(
    "WorkforcePilotRequest"
  );
  return {
    requestStatus: RequestStatus.SUCCESS,
    type: WorkforceTypeKeys.CHECK_WORKFORCE_COOKIE,
    cookieValue: workforcePilotCookie,
  };
}

export {
  joinWorkforcePilot,
  WorkforceTypeKeys,
  WorkforceActionTypes,
  viewWorkforceTeaser,
  checkWorkforceCookie,
};
